/**
 * Web re-export of the shared {@link mapAuthError} so both apps share one
 * source of truth for Supabase-auth error wording (see [[project_mobile_mirror_plan]]).
 */
export { mapAuthError } from "@tippo/logic";
